<template>
	<div class="row mb-3">
		<div class="col-3 col-sm-4">
			<!-- desktop -->
			<div class="d-none d-md-block body-strong text-grey-900 text-start">
				{{ store.state.content.planner_resumeTotal }}
			</div>
			<!-- mobile -->
			<div class="d-block d-md-none body-strong text-grey-900 text-start">
				{{ store.state.content.planner_resumeTotal }}
			</div>
		</div>
		<div
			class="col-9 col-sm-8 d-flex flex-column-reverse flex-md-row flex-nowrap justify-content-end justify-content-sm-between"
		>
			<ParticipantsTotals
				:participants="store.state.participants"
				:content="store.state.content"
				:additionalClasses="'justify-content-end body-strong text-grey-900'"
			/>
			<div class="d-flex flex-row flex-nowrap justify-content-end">
				<!-- <Prices
					:isLoading="pricesLoadingSet.has(currentCacheKey)"
					:crossedPrice="totals.crossedPrice"
					:totalPrice="totals.totalPrice"
					:perPrice="totals.perPrice"
					:maxPromo="totals.maxPromo"
					:locale="locale"
				/> -->
				<component
					:is="checkIfPerPersonDisplayWebsite ? PricesPP : Prices"
					:isLoading="pricesLoadingSet.has(currentCacheKey)"
					:crossedPrice="store.getters.totals.crossedPrice" 
					:totalPrice="store.getters.totals.totalPrice" 
					:perPrice="store.getters.totals.perPrice" 
					:maxPromo="store.getters.totals.maxPromo"
					:locale="store.getters.locale" 
					:totalParticipants="store.state.participants.length"
				></component>
			</div>
		</div>
	</div>
</template>

<script setup lang="ts">
import { computed } from "vue";
import { useStore } from "vuex";
import Prices from "@/vue/planning/components/common/prices.vue";
import ParticipantsTotals from "@/vue/planning/components/common/participantsTotals.vue";
import pricesLoadingSet from "@/vue/planning/state/pricesLoadingSet";
import currentCacheKey from "@/vue/planning/computed/currentCacheKey";
import PricesPP from "@/vue/planning/components/common/pricesPP.vue";
import getSiteFromDomain from "@/vue/planning/logic/getSiteFromDomain";

const store = useStore();

const checkIfPerPersonDisplayWebsite = computed(() => {
	return ["www.uk.travelski.com","www.nl.travelski.com"].includes(getSiteFromDomain(window.location.hostname));
});

</script>

<style scoped></style>
